import React from 'react';
import PropTypes from 'prop-types';
import { Typography, withStyles } from '@material-ui/core';

const styles = {
    root: {
        padding: '10px',
        textAlign: 'left'
    },
    header: {
        color: '#fff'
    }
};

const ContentHeader = ({ text, id, classes }) => (
    <div id={id} className={`${classes.root} content-header`}>
        <Typography variant="h5" className={classes.header}>
            {text}
        </Typography>
    </div>
);

ContentHeader.propTypes = {
    text: PropTypes.string.isRequired,
    id: PropTypes.string,
    classes: PropTypes.shape().isRequired
};

ContentHeader.defaultProps = {
    id: ''
};

export default withStyles(styles)(ContentHeader);
